import type { RouteRecordRaw } from 'vue-router';
import { isLocal, isDevelopment } from '@/shared/config/env';

// T-Filing 라우트는 dev / local 환경에서만 등록.
//   production 에서는 라우트 자체가 없으므로 메뉴 / 직접 URL 진입 모두 차단됨.
const isEnabled = isLocal() || isDevelopment();

export const tfilingHistoryRoutes: RouteRecordRaw[] = isEnabled
  ? [
      {
        path: '/tasks/tfiling-history',
        name: 'TFilingHistory',
        component: () => import('./views/TFilingHistoryPage.vue'),
        meta: {
          title: 'T-Filing History',
          requiresAuth: true,
          layout: 'default',
        },
      },
      // 카드 선택은 모달(NewTFilingModal) 사용. 카드 클릭 → 아래 standalone 라우트로 이동.
      {
        path: '/tasks/tfiling/new/:taskConfigCd',
        name: 'StandaloneEFiling',
        component: () => import('./views/StandaloneEFilingPage.vue'),
        meta: {
          title: 'Standalone e-Filing',
          requiresAuth: true,
          layout: 'default',
        },
      },
    ]
  : [];

export default tfilingHistoryRoutes;
